import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/shared/providers/auth/auth-service.service";
import { MenuItem } from "../../../models/menu-item";
import { UserProfileDto } from "src/app/admin/models/account-model";
import { AccountServiceService } from "src/app/services/AccountService";
import { App } from "src/app/admin/services/permission-checker";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  menuItems: MenuItem[] = [];
  userProfileDto: UserProfileDto = {} as UserProfileDto;
  isDropDownOpen: Boolean = false;
  constructor(
    private cd: ChangeDetectorRef,
    private authService: AuthService,
    private accountService: AccountServiceService
  ) {}

  ngOnInit(): void {
    App.auth.getPermissions(this.accountService);
    this.prepareMenuItem();
    this.getProfile();
  }
  logout() {
    this.authService.adminLogout();
  }

  private getProfile(): void {
    this.authService.adminProfile().subscribe((result: UserProfileDto) => {
      this.userProfileDto = result;
    });
  }
  private prepareMenuItem(): void {
    this.menuItems = [
      new MenuItem(
        "/admin",
        "الرئيسية",
        "fa-regular fa-house",
        "dashboard",
        "",
        true,
        ""
      ),
      new MenuItem(
        "/dashboard",
        "قيود الامتياز",
        "fa-regular fa-file-contract",
        "franchises",
        "",
        true,
        "Pages.Franchise.Default",
        this.franchiseSubMenuItems()
      ),
      new MenuItem(
        "/admin/DonorRequest",
        "طلبات القيود",
        "fa-regular fa-file-contract",
        "donor-requests",
        "",
        true,
        "Pages.Franchise.Default"
      ),
      new MenuItem(
        "/admin/User",
        "إدارة المستخدمين",
        "fa-regular fa-users",
        "users-management",
        "",
        true,
        "Pages.User.Default"
      ),
      new MenuItem(
        "/admin/Reasons",
        "إدارة الأسباب",
        "fa-regular fa-pen-field",
        "resones-management",
        "",
        true,
        "Pages.Reason.Default"
      ),
    ];
  }
  private franchiseSubMenuItems(): MenuItem[] {
    this.isDropDownOpen =
      window.location.href.includes("ExternalFranchises") ||
      window.location.href.includes("InternalFranchises");
    return [
      new MenuItem(
        "/admin/InternalFranchises",
        "القيود الداخلية",
        "fa-regular fa-file-contract",
        "internal-franchises",
        "changeopcity",
        true,
        "Pages.Franchise.Default"
      ),
      new MenuItem(
        "/admin/ExternalFranchises",
        "القيود الخارجية",
        "fa-regular fa-file-contract",
        "external-franchises",
        "changeopcity",
        true,
        "Pages.Franchise.Default"
      ),
    ];
  }
  CloseDropDown() {
    this.isDropDownOpen = false;
  }
  OpenDropDown() {
    this.isDropDownOpen = true;
  }
  ToggleDropDown() {
    this.isDropDownOpen = !this.isDropDownOpen;
  }
}
